import { Input, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  [data-input-right-icon] {
    color: var(--text-soft);
    ${typographyV2.bodyBase};
  }
`;
